module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAABvSURBVEiJ7ZLRCoAgDEWPX9b+LPuy9MvqoUkEmpN8CXZgTGHuXi6C4xiIwKHdTDDOidYCZO0AG5BGBFtE6u4F2LVk9vLhuVpcwtNZT6S8WfXcjbDryiDWjPDr8td9gTuexKSfoghXhLlcHMdx/sQJdEEbuYo8RZMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/up-icon.png
// module id = eoiH
// module chunks = 1